import type { TFunction } from "i18next";

const OFFERS_LABEL_KEYS: Record<string, string> = {
  "Total Revenue": "analytics.offers.kpi.totalRevenue",
  "Conversion rate": "analytics.offers.kpi.conversionRate",
  "Guests offered": "analytics.offers.kpi.guestsOffered",
  "Avg. Revenue": "analytics.offers.kpi.avgRevenue",
  "Total guests contacted": "analytics.offers.kpi.totalGuestsContacted",
  "Only Opened": "analytics.offers.kpi.onlyOpened",
  Skipped: "analytics.offers.kpi.skipped",
  "Upsell Offers": "analytics.offers.sections.upsellOffers",
  "Upsell Offers: Step 5": "analytics.offers.sections.upsellOffersStep5",
  "Service Offers": "analytics.offers.sections.serviceOffers",
  "Activities offers": "analytics.offers.sections.activitiesOffers",
  "Catalog price": "analytics.offers.table.catalogPrice",
  Revenue: "analytics.offers.table.revenue",
};

export function translateOffersLabel(t: TFunction, label: string): string {
  const key = OFFERS_LABEL_KEYS[label];
  return key ? t(key, label) : label;
}
